import Modal from './Modal';
import avatars from '../config/avatars';
import { updateUserPropertiesMutation } from '../resources/Auth/mutations';
import { CurrentUserMustResource } from '../resources/Auth/CurrentUserMust';
import Button from './Button';
import useCopy from '../util/useCopy';
import { AvatarInput } from './AvatarInput';

type AvatarId = keyof typeof avatars;

let ChooseAvatarModal = ({
  isOpen,
  onClose,
  onChoose,
  avatarIdOverride,
}: {
  avatarIdOverride?: string;
  isOpen: boolean;
  onClose: () => void;
  onChoose: (avatarId: string) => void;
}) => {
  let currentUser = CurrentUserMustResource.use();
  let copy = useCopy();

  let selectedAvatarId = (avatarIdOverride ||
    currentUser.avatarId ||
    'AVATAR_0') as AvatarId;
  let selectedColor = currentUser.avatarBackgroundHex || null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} disableBodyPadding>
      <AvatarInput
        value={{
          avatarId: selectedAvatarId,
          avatarBackgroundHex: selectedColor,
        }}
        onChange={(newValue) => {
          if (newValue.avatarBackgroundHex !== selectedColor) {
            updateUserPropertiesMutation({
              avatarBackgroundHex: newValue.avatarBackgroundHex,
              userId: currentUser.id,
            });
          }
          if (newValue.avatarId !== selectedAvatarId) {
            onChoose(newValue.avatarId);
          }
        }}
      />

      <Modal.BottomActions>
        <Button onClick={onClose}>{copy.Done}</Button>
      </Modal.BottomActions>
    </Modal>
  );
};

export default ChooseAvatarModal;
